export enum AnalyseShowAllLocationsTabs {
  COUNTRIES = 0,
  SITES = 1,
  MY_SITES = 2,
  MAPLECROFT_RISK_VIEWS = 3,
  MY_RISK_VIEWS = 4,
}
